import {connect} from 'react-redux';
import Form from '../components/VerifierForm';
import {stopVerifying, loadProviders} from '../actions';
import { mapVerifierFormToProps } from '../selectors';

export default connect(mapVerifierFormToProps, {onSubmit: stopVerifying, loadProviders})(Form);